import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { css } from 'styled-components';
var def = function def(value, predef) {
  if (value === 'default') return predef;
  return value !== null && value !== void 0 ? value : false;
};
export var focusOutlineCss = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  outline: ", " solid ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.focusWidth;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.focusColor;
});
export var fallbackFocusWithinCss = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n\n  &:focus-within::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 1;\n\n    margin: -3px;\n    border-radius: ", ";\n    box-shadow: ", ";\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.focusRadius;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.focusBoxShadow;
});
export var focusVisibleWithBefore = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n\n  &:focus-visible::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 1;\n\n    border: ", " solid ", ";\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.focusWidth;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.focusColor;
});
export var focusOutline = function focusOutline() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref7$offset = _ref7.offset,
    offset = _ref7$offset === void 0 ? null : _ref7$offset,
    _ref7$radius = _ref7.radius,
    radius = _ref7$radius === void 0 ? null : _ref7$radius;
  return function (_ref8) {
    var theme = _ref8.theme;
    var withOffset = def(offset, theme.focusOffset);
    var withRadius = def(radius, theme.focusRadius);
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      ", "\n      ", "\n      ", "\n    "])), focusOutlineCss, withOffset && "outline-offset: ".concat(withOffset, ";"), withRadius && "border-radius: ".concat(withRadius, ";"));
  };
};
export var focusVisibleWithOutline = function focusVisibleWithOutline() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref9$offset = _ref9.offset,
    offset = _ref9$offset === void 0 ? null : _ref9$offset,
    _ref9$radius = _ref9.radius,
    radius = _ref9$radius === void 0 ? null : _ref9$radius;
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    &:focus-visible {\n      ", "\n    }\n  "])), focusOutline({
    offset: offset,
    radius: radius
  }));
};
//# sourceMappingURL=focus-indicator.js.map